<template>
  <div class="container">
    <InstructionModal v-show="isModalVisible" :copy="copy"></InstructionModal>
    <SignatureForm :copy="copy"></SignatureForm>
  </div>
</template>

<script>
import SignatureForm from "@/components/SignatureForm";
import InstructionModal from "@/components/InstructionModal";
import { bus } from "@/main.js";

export default {
  name: "home",
  data() {
    return {
      isModalVisible: true,
      copy: {
        vantorToolTitle: "Vantor Signature Generator",
        instructionHeader:
          "The Email Signature Tool is an easy-to-use tool to create your unique email signature for Outlook.",
        instructionIntroText:
          "Google Chrome or Firefox are the recommended browsers for the signature tool. You may also use Internet Explorer (11 version or later). Using other browsers, such as Safari, may result in irregular formatting.",
        points: [
          "Fill out the form with your name and contact information (Note: enter the email address you are using today).",
          "Verify the email signature content, then select and copy your email signature.",
          "Paste your signature into Outlook. *",
          "In order to have consistent layout, please do not add additional words, photos, logos or slogans to your email signature.",
          "In order to prevent formatting issues, first paste the signature into a blank email first in outlook, then copy that and paste it into the Outlook signature tool.",
        ],
        instructionDisclaimer:
          "*In Outlook 2013, open a new email. In the message, go to the Signature drop-down button, Click on Signatures, select new and give the new signature a name. Paste in the new email signature and click OK.",
        chooseOrganization: "Choose your organization",
        colorLabel: "Color scheme",
        colors: [
          {
            color: "Gold",
            value: "gold",
          },
        ],
        nameLabel: "name",
        namePlaceholder: "First M. Last",
        pronounLabel: "Include Pronoun",
        pronounPlaceholder: "ex. he, him, his",
        titleLabel: "Include title",
        titlePlaceholder: "Title",
        departmentLabel: "Include division/department",
        departmentPlaceholder: "My division/department",
        officePhoneLabel: "Phone number 1",
        officePhoneLabelLabel: "Phone 1 label (ex. Office or O)",
        phone2Label: "Include additional phone 2",
        phone2Placeholder: "Type additional phone 2 label here",
        phone3Label: "Include additional phone 3",
        phone3Placeholder: "Type additional phone 3 label here",
        phone4Label: "Include additional phone 4",
        phone4Placeholder: "Type additional phone 4 label here",
        phoneOfficeLabel: "Phone 1 label",
        emailLabel: "Email",
        addressLabel: "Include office address",
        emailNewNote: "INCLUDE EMAIL LABEL “New Email Address”",
        socialMediaLabel: "Include social media icons",
        phoneOfficePlaceholder: "O",
        imageBtnTxt: "Get image",
        closeImageBtnTxt: "Close image",
        pasteImageTxt:
          "Right click on the image and save it to your computer. Paste the item into your Outlook signature",
      }
    };
  },
  created() {
    bus.$on("closeAppModal", () => {
      this.isModalVisible = false;
    });
  },
  components: {
    SignatureForm,
    InstructionModal,
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: "TWKEverett", "Aptos", Arial, "Open Sans", sans-serif;
}

header {
  color: white;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

</style>
